import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlayBackComponent } from './play-back.component';


const routes: Routes = [
  { path: 'list', component: PlayBackComponent,  pathMatch : 'full' },
  { path: '**', redirectTo : 'list' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlayBackRoutingModule { }
